<template>
    <v-container style="padding: 0 10%">
        <vueHeadful
        :title="this.$i18n.t('Menu.AdministracionCertificados') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12">
              <v-text-field solo v-model="buscar" :label="$t('Busqueda.Buscar')"></v-text-field>
                <v-data-table
                :search="buscar"
                :headers="headers"
                :items="certificados">
                <template v-slot:[`item.pais`]="{ item }">
                    <span v-if="item.pais">{{item.pais}}, {{item.ciudad}}</span>
                </template>
                <template v-slot:[`item.ver`]="{ item }">
                    <v-btn icon :href="item.urlCertificado_bancario" target="_blank"><v-icon color="black">far fa-eye</v-icon></v-btn>
                </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdministracionContratos',
  data () {
    return {
      buscar: null,
      dialog: false,
      elegido: null,
      indexElegido: null,
      comentario: null,
      contratos: [],
      certificados: [],
      headers: [
        { text: this.$i18n.t('Formularios.Nombre'), value: 'nombre' },
        { text: this.$i18n.t('Formularios.Pais'), value: 'pais' },
        { text: this.$i18n.t('Formularios.Email'), value: 'email' },
        { text: this.$i18n.t('Formularios.Telefono'), value: 'telefono' },
        { text: this.$i18n.t('Formularios.Ver'), value: 'ver' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getCargandoAccion'])
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setCargandoAccion']),
    ...mapActions(['enviarCorreo'])
  },
  mounted () {
    firebase.firestore().collection('certificados_bancarios').get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.certificados.push(info.docs[i].data())
      }
    })
  }
}
</script>
